module.exports = __webpack_public_path__ + "static/media/NOBA_Viinistu.f137e9f2.svg";